export const FLOORPLAN_LAYER = {
  drawerSubmenuClass: 'z-30',
  toolbarClass: 'z-30',
  colorPickerPopover: 40,
  colorPickerModal: 40,
  colorPickerPreviewClass: 'z-50',
} as const;
